export const CHECK_TYPE = {
    New: 'new', // publishDate 不传值代表，代表 新文献
    Published: 'published'  // publishDate 传值代表，代表 已发表论文
}

export const CHECK_ENGINE_TYPE = {
    WangFang: 'wanFang'
}

export const PARTNER_CODE = {
    WF: 'WF'
}

export const PARTNER_CODE_MAP = {
    [CHECK_ENGINE_TYPE.WangFang]: PARTNER_CODE.WF
}

export const PARTNER_CODE_ENGINE_MAP = {
    [PARTNER_CODE.WF]: CHECK_ENGINE_TYPE.WangFang
}

export const CHECK_STATUS_TYPE = {
    Checking: 'Checking',
    Error: 'Error',
    Success: 'Success'
}


export const APP_STORE_PAPER_CHECK_STATUS_TYPE = {
    STATUS_DEFAULT: 'default',
    STATUS_WAITING_PAY: 'waiting_pay',
    STATUS_PAID: 'paid',
    STATUS_CHECKING: 'checking',
    STATUS_FINISHED: 'finished',
    STATUS_FAILURE: 'failure'
}

export const AVAILABLE_STATUS = {
    ...CHECK_STATUS_TYPE,
    STATUS_WAITING_PAY: APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_WAITING_PAY,
    STATUS_PAID: APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_PAID,
}

export const APP_STORE_STATUS_TO_CHECK_STATUS_MAP = {
    [APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_DEFAULT]: APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_DEFAULT,
    [APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_WAITING_PAY]: APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_WAITING_PAY,
    [APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_PAID]: APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_PAID,
    [APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_CHECKING]: CHECK_STATUS_TYPE.Checking,
    [APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_FINISHED]: CHECK_STATUS_TYPE.Success,
    [APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_FAILURE]: CHECK_STATUS_TYPE.Error
}

export const CHECK_ERROR_TYPE = {
    Exception: 'Exception', //没有checkId产生
    Error: 'Error', // 某论文确实无法查重，万方测置 Error
    Timeout: 'Timeout' // 某论文  检测超过两个小时 没有返回结果
}

export const CHECK_FILE_TYPE = {
    Txt: 'txt',
    Rtf: 'rtf',
    Doc: 'doc',
    Docx: 'docx',
    PDF: 'pdf'
}

export const UPLOAD_ACCEPTS = Object.values(CHECK_FILE_TYPE).reduce((prev, cur, index) => {
    if (index === 0) {
        return `${prev}.${cur}`;
    }
    return `${prev},.${cur}`;;
}, '');

export const CHECK_STEPS_MAP = {
    Setting: 0,
    Payment: 1,
    Finish: 2,
}

export const CHECK_STEPS_MAP_KEYS = Object.keys(CHECK_STEPS_MAP);


export const DEFAULT_CHECK_INFO = {
    orderId: '',
    checkId: '',
    checkTitle: '',
    checkAuthor: '',
    checkLetterCounts: null,
    checkTotalPrice: null,
    checkFileType: CHECK_FILE_TYPE.PDF,
    checkType: CHECK_TYPE.New,
    checkEngine: CHECK_ENGINE_TYPE.WangFang,
    checkStatus: CHECK_STATUS_TYPE.Checking,
    checkContent: '', // 送检内容
    checkPublishDate: '', // 收稿日期，已发布论文需要
    checkErrorType: '',
    checkOrderTime: '',
    checkStartTime: '',
    checkTotalCopyPercent: null
}

export const CHECK_SUPPORT_FILE_TYPES = Object.keys(CHECK_FILE_TYPE).map(type => CHECK_FILE_TYPE[type]);

export const CHECK_REPORT_EXPIRED_TIME = 30 * 24 * 60 * 60 * 1000; // 查重结果保留时间

export const CHECK_TIMEOUT_TIME = 2 * 60 * 60 * 1000; //  检测超过两个小时, 检测超时时间

export const CHECK_COPY_PERCENT_THRESHOLD_VALUE = 30; // 超过30% 重复率较高

export const CHECK_MAX_COUNTS = 1000000; // 最大检测 100万
export const CHECK_MAX_CHARACTERS = 1000000; // 最大检测 100万字符

export const PCHECKER_JAEGERDATA_MAP = {
    PChecker_dis_click: {
        action: 'PChecker_dis_click',
        label: 'Discover'
    },
    PChecker_home_click: {
        action: 'PChecker_home_click',
        label: 'Home'
    },
    PChecker_tab_PTS_click: {
        action: 'PChecker_tab_PTS_click',
        label: 'Tab_PTS'
    },
    PChecker_file_loading: {
        action: 'PChecker­_file_loading',
        label: 'PChecker_dialog'
    }
};

export const EMAIL_REG = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
